import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";

export function ArraySubTable(props: SvgIconProps) {
  return (
    <SvgIcon {...props}>
      <path d="M1 4C1 2.34315 2.34315 1 4 1H18C19.6569 1 21 2.34315 21 4V11H19H12V15V17H4C2.34315 17 1 15.6569 1 14V4ZM10 15V11H3V14C3 14.5523 3.44772 15 4 15H10ZM12 9H19V5H12V9ZM10 5H3V9H10V5ZM15 13H14V14V22V23H15H17V21H16V15H17V13H15ZM21 13H22V14V22V23H21H19V21H20V15H19V13H21Z" />
    </SvgIcon>
  );
}
